export default () => {
	const counter = document.querySelector('.js-ph-count');

	if (counter) {
		const cards = document.querySelectorAll('.card');
		const countVal = cards.length;

		if (countVal) {
			counter.innerText = countVal;
		}
	}
}
